/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationRead } from './OrganizationRead';
import {
    OrganizationReadFromJSON,
    OrganizationReadFromJSONTyped,
    OrganizationReadToJSON,
    OrganizationReadToJSONTyped,
} from './OrganizationRead';

/**
 * Paginated response for the superadmin organization list.
 * @export
 * @interface PaginatedOrganizationsResponse
 */
export interface PaginatedOrganizationsResponse {
    /**
     * Organizations on this page
     * @type {Array<OrganizationRead>}
     * @memberof PaginatedOrganizationsResponse
     */
    items: Array<OrganizationRead>;
    /**
     * Total number of matching organizations
     * @type {number}
     * @memberof PaginatedOrganizationsResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedOrganizationsResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedOrganizationsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedOrganizationsResponse interface.
 */
export function instanceOfPaginatedOrganizationsResponse(value: object): value is PaginatedOrganizationsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedOrganizationsResponseFromJSON(json: any): PaginatedOrganizationsResponse {
    return PaginatedOrganizationsResponseFromJSONTyped(json, false);
}

export function PaginatedOrganizationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedOrganizationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(OrganizationReadFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedOrganizationsResponseToJSON(json: any): PaginatedOrganizationsResponse {
    return PaginatedOrganizationsResponseToJSONTyped(json, false);
}

export function PaginatedOrganizationsResponseToJSONTyped(value?: PaginatedOrganizationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(OrganizationReadToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

